module.exports = require("lodash/max");